export default "__VITE_ASSET__DVOTY3i0__"